import { BulkRequestRoute } from "route-components/BulkRequestRoute";
import { balanceAges } from "components/PaymentsLanding/Tabs/BulkRequest/balanceMap";
import { bulkRequestFilterInitialState } from "components/PaymentsLanding/Tabs/BulkRequest/BulkRequestBar/BulkRequestFilterBar/bulkRequestFilterState";
import { createFileRoute } from "@tanstack/react-router";
import { forBoth } from "utils/generics";
import type { BalanceAge } from "api/responses";

interface BulkRequestSearchParamsBase {
    readonly minBalanceEnabled: boolean;
    readonly minBalance: number | null;
    readonly patient: string;
    readonly excludeOutstandingClaims: boolean;
    readonly excludeActivePaymentPlans: boolean;
    readonly excludeMedicaid: boolean;
}

export interface BulkRequestSearchParams extends BulkRequestSearchParamsBase {
    readonly agings: ReadonlySet<BalanceAge>;
}

export interface BulkRequestSearchParamsQuery extends BulkRequestSearchParamsBase {
    readonly agings: BalanceAge[];
}

type BulkRequestSearchParamsPartial = Partial<BulkRequestSearchParamsQuery>;

export const Route = createFileRoute("/history/bulk-request")({
    component: BulkRequestRoute,
    validateSearch: (search: BulkRequestSearchParamsPartial): BulkRequestSearchParamsPartial => {
        // Convert agings string array to BalanceAge array, defaulting to all if not set
        const agingsArray = Array.isArray(search.agings) && search.agings.length > 0 ? search.agings : balanceAges;

        const withDefault = <T extends keyof typeof search & keyof typeof bulkRequestFilterInitialState>(k: T) =>
            forBoth(search, bulkRequestFilterInitialState, k, (searched, initial) => searched ?? initial);

        return {
            agings: agingsArray as BalanceAge[],
            minBalanceEnabled: withDefault("minBalanceEnabled"),
            minBalance: typeof search.minBalance === "number" ? search.minBalance : null,
            patient: typeof search.patient === "string" ? search.patient : "",
            excludeOutstandingClaims: withDefault("excludeOutstandingClaims"),
            excludeActivePaymentPlans: withDefault("excludeActivePaymentPlans"),
            excludeMedicaid: withDefault("excludeMedicaid"),
        } satisfies BulkRequestSearchParamsQuery;
    },
});
